<script setup>
import { ref, computed } from 'vue'
import { useArticleSearch } from '../composables/ArticleSearch.js'

const {
  searchText,
  searchResults,
  clearSearchText,
  selectSearchResult,
} = useArticleSearch();

// selectedItemId
// promptDeleteItemId
</script>

<template>
  <!-- Search results -->
  <div class="mb-8">
    <div class="mt-8"><span class="text-lg font-medium dark:text-gray-200">Iskalni zadetki</span><span class="pl-2 relative" style="bottom: 1px">({{ searchResults?.length ? searchResults.length : "brez zadetkov" }})</span></div>

    <Button type="primary" class="mt-2" @click="() => clearSearchText()">Počisti iskalni niz</Button>

    <!-- List of search results -->
    <div class="relative grid grid-cols-1 gap-4 w-full mt-8 mb-8" v-if="searchResults?.length">
      <a href="#" v-for="(row, i) in searchResults" @click.prevent="selectSearchResult(row)"
        class="py-4 relative flex bg-white dark:bg-gray-800 border rounded-lg shadow hover:border-blue-600 dark:border-gray-700"
        :class="{ 'row-article': row.isArticle, 'row-category': row.isCategory }">

        <!-- Search result image -->
        <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-if="row.thumbnailUrl">
          <img :src="row.thumbnailUrl" alt="" style="max-width: 50px; max-height: 50px;" />
        </div>
        <!-- :class="{ 'text-blue-200': selectedItemId == row.id && promptDeleteItemId != row.id, 'text-red-300': promptDeleteItemId == row.id }" -->
        <div class="grid place-items-center text-gray-200 dark:text-gray-700 text-center w-24 mx-4" style="font-size: 48px; width: 50px; height: 50px;" v-else>
          <i class="fa fa-image"></i>
        </div>

        <!-- Search result name -->
        <div class="w-full pr-3 grid items-center">
          <h5 class="text-md tracking-tight text-gray-900 dark:text-gray-800 dark:text-white" v-if="row.name">{{ row.name }}</h5>
          <h3 class="mt-0 text-slate-400 dark:text-gray-200" v-if="row.isCategory">Kategorija</h3>
          <h3 class="mt-0 text-slate-400 dark:text-gray-200" v-if="row.isArticle">Artikel {{ row.sku }}</h3>
        </div>

        <!-- <i class="fa fa-magnifying-glass absolute right-0 bottom-0 m-2" :class="{ 'text-gray-900/10': row.isArticle, 'text-amber-100': row.isCategory }" style="font-size: 24px; pointer-events: none;"></i> -->
        <!-- <i class="fa fa-filter text-gray-200 absolute right-0 bottom-0 m-2" style="font-size: 24px; pointer-events: none;"></i> -->

      </a>

      <!-- Scrollable offset - height of keyboard -->
      <div class="w-full" style="height: 320px;"></div>
    </div>

  </div>
</template>

<style scoped>
.row-category {
  @apply border-gray-200;
  background: linear-gradient(320deg, #fef3c7 0%, rgba(255,255,255,1) 70%);
}

.row-article {
  @apply border-gray-200;
  background: linear-gradient(320deg, #e2e8f0 0%, rgba(255,255,255,1) 70%);
}

.dark .row-category {
  @apply bg-gray-800 border-gray-700;
  border-color: rgb(26, 86, 219);
  background: rgb(35, 56, 118);
}

.dark .row-article {
  @apply bg-gray-800 border-gray-700;
  background: rgb(31, 41, 55);
}
</style>